import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div data-testid="page-not-found" className="mx-auto max-w-2xl px-6 py-32 text-center">
      <Seo title="Page not found" description="The page you're looking for doesn't exist or has moved." />
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-sage-light text-terracotta">
        <Compass size={26} strokeWidth={1.5} />
      </span>
      <h1 className="mt-6 text-3xl font-light tracking-tight text-charcoal-900">This page took a wrong turn</h1>
      <p className="mt-3 text-charcoal-600">
        The page you're looking for doesn't exist or may have moved. Let's get you back on the road.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link to="/" data-testid="notfound-home" className="rounded-full bg-terracotta px-7 py-3 text-white font-medium hover:bg-terracotta-hover transition-colors">
          Back home
        </Link>
        <Link to="/explore-mexico" data-testid="notfound-explore" className="rounded-full border border-charcoal-300 px-7 py-3 text-charcoal-800 font-medium hover:bg-sand-200 transition-colors">
          Explore guides
        </Link>
        <Link to="/contact" data-testid="notfound-contact" className="rounded-full border border-charcoal-300 px-7 py-3 text-charcoal-800 font-medium hover:bg-sand-200 transition-colors">
          Contact us
        </Link>
      </div>
    </div>
  );
}
